"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import classNames from "classnames";
import React from "react";
import Tooltip from "../Tooltip/Tooltip";
import { handleMouseUpByBlurring } from "../../../utils/focus";
export var OptionGroupSize = /* @__PURE__ */ ((OptionGroupSize2) => {
  OptionGroupSize2["Small"] = "small";
  OptionGroupSize2["Large"] = "large";
  return OptionGroupSize2;
})(OptionGroupSize || {});
const OptionGroup = (props) => {
  const { options, selectedValue, onClickHandler } = props;
  const size = props.size || "small" /* Small */;
  const optionComponents = options.map((option, index) => {
    return renderOption(size, option, selectedValue, onClickHandler, index, options.length);
  });
  return /* @__PURE__ */ React.createElement("div", { className: "option-group" }, props.label && /* @__PURE__ */ React.createElement("div", { className: "option-group__label" }, props.label), /* @__PURE__ */ React.createElement("div", { className: classNames("option-group__content", `option-group__content--${size}`) }, optionComponents));
};
export const StricterOptionGroup = (props) => {
  return /* @__PURE__ */ React.createElement(OptionGroup, __spreadValues({}, props));
};
const renderOption = (size, option, selectedValue, onClickHandler, index, length) => {
  const handleClick = (event) => {
    event.stopPropagation();
    onClickHandler(option.value);
  };
  const optionComponent = /* @__PURE__ */ React.createElement(
    "button",
    {
      key: option.value.toString(),
      className: classNames("option-group__button", `option-group__button--${size}`, "center", {
        "option-group__button--selected": selectedValue === option.value,
        "option-group__button--first": index === 0,
        "option-group__button--last": index === length - 1
      }),
      onClick: handleClick,
      onMouseUp: handleMouseUpByBlurring
    },
    /* @__PURE__ */ React.createElement("div", { className: "option-group__button-content center" }, renderOptionContent(option))
  );
  if (option.tooltipMessage !== void 0) {
    return /* @__PURE__ */ React.createElement(Tooltip, { key: option.value.toString(), content: option.tooltipMessage }, optionComponent);
  } else {
    return optionComponent;
  }
};
const renderOptionContent = (option) => {
  if (option.icon) {
    return option.icon;
  } else {
    return option.label;
  }
};
export default OptionGroup;
